import httpClient from './httpClient'

const AgencyMarginApi = {
  async fetch(id) {
    try {
      const res = await httpClient.get(`/agency_margin/${id}`)
      return res.data
    } catch (e) {
      console.error(e)
      throw new Error(`Error: GET /agency_margin/${id}`)
    }
  },
  async search(query, pageNo, pageSize) {
    try {
      const res = await httpClient.post('/agency_margin/search', {
        query,
        pageNo,
        pageSize,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchList(params) {
    try {
      const res = await httpClient.get('/request/agency_margin', {
        params: params,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async deleteRequest(id) {
    try {
      const res = await httpClient.delete(`/request/agency_margin/${id}`)
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async createRequest(params) {
    try {
      const res = await httpClient.post('/request/agency_margin', {
        params: params,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  /*
  async addAgency(body) {
    try {
      return await httpClient.post('/agency', body)
    } catch (e) {
      console.log(e)
    }
  },
  async editAgency(id, body) {
    try {
      return await httpClient.put(`/agency/${id}`, body)
    } catch (e) {
      console.log(e)
    }
  },
  */
}

export default AgencyMarginApi
